import { resolvePackageServiceGlyph } from './packageServiceIcons';

export default function ServiceIconGlyph({ icon, className }) {
  const glyph = resolvePackageServiceGlyph(icon);
  if (glyph.type === 'svg') {
    return (
      <span
        className={['icon-glyph', className].filter(Boolean).join(' ')}
        style={{ '--icon-url': `url(${glyph.src})` }}
        aria-hidden='true'
      />
    );
  }
  if (!glyph.className) return null;
  return <i className={glyph.className} aria-hidden='true' />;
}
